module.exports = __webpack_public_path__ + "img/f.62aee421.png";